import { render, staticRenderFns } from "./CancellationPolicies.vue?vue&type=template&id=5f0c11cc&scoped=true"
import script from "./CancellationPolicies.vue?vue&type=script&lang=js"
export * from "./CancellationPolicies.vue?vue&type=script&lang=js"
import style0 from "./CancellationPolicies.vue?vue&type=style&index=0&id=5f0c11cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0c11cc",
  null
  
)

export default component.exports